export function numberWithCommas(num, decimals) {
  const roundNum = Number(num).toFixed(decimals)
  const parts = roundNum.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
}
